import { render, staticRenderFns } from "./provinces.vue?vue&type=template&id=40551b37&scoped=true"
import script from "./provinces.vue?vue&type=script&lang=js"
export * from "./provinces.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40551b37",
  null
  
)

export default component.exports